import React, {memo, useCallback} from "react";
import styles from "./VideoSuggestion.module.css";
import {Video} from "../../../../common/video/models/Video";
import VideoMetadataLine from "../../../../common/components/videoMetadataLine/VideoMetadataLine";
import {Link, useNavigate} from "react-router-dom";
import PresenterIcon from "../../../../common/components/icons/PresenterIcon";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import NewIcon from "../../../../common/components/images/NewIcon";
import useResponsive from "../../../../common/useResponsive";

interface VideoSuggestionProps {
  video: Video;
}

function VideoSuggestion({video}: VideoSuggestionProps) {
    const history = useNavigate();
    const goToVideo = useCallback(
        () => history(`/video/${video.hash}`),
        [video, history]
    );
    const {isMobile} = useResponsive();
    return (
        <div className={styles.root} onClick={goToVideo}>
            <img
                className={styles.thumbnail}
                src={video.imageUrl}
                alt=""
            />

            {/* 新規ビデオアイコン */}
            {video.visibleNewIcon && (
                <div className={styles.newIcon}>
                    <NewIcon/>
                </div>
            )}
            <div className={styles.text}>
                <div className={styles.textUpper}>
                    <div className={styles.title} data-tip={video.title} data-for="title">
                        <Link to={`/video/${video.hash}`}>
                            <PuiTypography size={isMobile ? 14 : 16}>{video.title}</PuiTypography>
                        </Link>
                    </div>
                    <PuiTooltip id="title"/>
                    <div className={styles.presenter}>
                        <div className={styles.presenterIcon}>
                            <PresenterIcon color="grey-42"/>
                        </div>

                        <PuiTypography size={isMobile ? 12 : 14} color="gray-61">
                            {video.presenter}
                        </PuiTypography>
                    </div>
                </div>

                <VideoMetadataLine variant="compact" video={video} fontSize={isMobile ? 12 : 16}/>
            </div>
        </div>
    );
}

export default memo(VideoSuggestion);
